class ScheduleParser {

    days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

    constructor(schedule) {
        this.schedule = schedule;
    }

    getCurrentDay() {
        let now = new Date();
        return this.days[now.getDay()];
    }

    static getDiffHours(startHour, endHour) {
        return Math.abs(startHour - endHour)
    };

    static openCloseToRang(startTime, endTime) {
        const minutesOfStartTime = startTime.slice(-2);
        if (minutesOfStartTime != 0) { //skip the hour if minutes != 00
            let startHourOnly = parseInt(startTime.substr(0, 2));
            if (startHourOnly < 24) {
                startHourOnly++;
                startTime = `${startHourOnly}:00`;
            }
        }
        let rang = [];
        const startHour = new Date("01/01/2007 " + startTime).getHours();
        const endHour = new Date("01/01/2007 " + endTime).getHours();
        const diff = this.getDiffHours(startHour, endHour);
        var i;
        for (i = startHour; i < diff; i++) {
            rang.push([i, i + 1])
        }
        return rang;
    }

    static dayToFullRang(arrayOfOpenClosed) {
        let fullRang = [];
        arrayOfOpenClosed.map((openCloseArray) => {
            const openClosedToRang = this.openCloseToRang(openCloseArray[0], openCloseArray[1]);
            fullRang.push(openClosedToRang)
        })
        return fullRang.flat().filter(this.onlyUnique);
    }


    static onlyUnique(value, index, self) {
        return self.indexOf(value) === index;
    }

    static expectedTimeToAmPM(time) {
        //if we get something like 18:00 we should display => 6:00 PM-7:00
        const hoursOnly = time.slice(0, 2);
        let toHour = hoursOnly - 12
        if (toHour === 12) {
            toHour = 1;
        } else {
            toHour++;
        }
        toHour = toHour + 12
        return `${this.toAmPm(hoursOnly)} - ${this.toAmPm(toHour)}`;
    }


    static dateObjectToDateString(dateObject) {
        const monthNumber = dateObject.getMonth() + 1;
        const month = monthNumber > 9 ? monthNumber : `0${monthNumber}`;
        return dateObject.getFullYear() + "-" + month + "-" + dateObject.getDate();
    }

    static sortSchedule(schedule, dayIndex, days) {
        //sort schedule with given days week
        let orderedSchedule = {};
        for (let i = dayIndex; i < days.length; i++) {
            if (schedule[days[i]]) {
                orderedSchedule[days[i]] = schedule[days[i]];
            }
        }
        for (let J = 0; J < dayIndex; J++) {
            if (schedule[days[J]]) {
                orderedSchedule[days[J]] = schedule[days[J]];
            }
        }
        return orderedSchedule;

    }

    handle() {
        const today = new Date();
        const todayIndex = today.getDay();
        const todayName = this.days[todayIndex];
        const currentHour = today.getHours();
        let finalResult = [];
        const orderedSchedule = this.constructor.sortSchedule(this.schedule, todayIndex, this.days);
        for (const key in orderedSchedule) {
            const dateObject = this.nextDay(this.days.indexOf(key))
            const dateString = this.constructor.dateObjectToDateString(dateObject);
            let hours = this.constructor.dayToFullRang(this.schedule[key]);
            finalResult.push({displayDate: dateObject.toDateString().substr(3), dateString, hours});
        }
        /**
         *  if today is found in the schedule
         *  we must exclude the passed hours
         */
        if (orderedSchedule[todayName]) {
            finalResult[0].hours = finalResult[0].hours.filter((openCloseArray) => openCloseArray[0] > currentHour) //which means it is on the first
            finalResult[0].hours.shift();
            finalResult[0].hours.shift();
            if (finalResult[0].hours.length === 0) { //starts a new day
                finalResult.shift();
            }

        }
        return finalResult;
    }

    nextDay(x) {
        const now = new Date();
        now.setDate(now.getDate() + (x + (7 - now.getDay())) % 7);
        return now;
    }

    static toAmPm(hours) {
        var mid = 'AM';
        if (hours == 0) { //At 00 hours we need to show 12 am
            hours = 12;
        } else if (hours > 12) {
            hours = hours % 12;
            mid = 'PM';
        }
        return `${hours}:00 ${mid}`
    }

}


export default ScheduleParser;
